var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Consent',{staticClass:"consent",attrs:{"cancelLabelI18nKey":"common.btn.back","submitLabelI18nKey":"common.btn.save"}})
}
var staticRenderFns = []

export { render, staticRenderFns }